<template>
  <div   class="animated fadeIn">
      <Alerts ref="alert"/>
      <b-tabs v-model="tabIndex">
        <b-tab :title="$lang.CarInspection.General.Search" v-if="hasRole(this.roles.RW_REG_TABSEARCH)" active  @click="setTabName('Search')">
          <template slot="title">
            <i class="fa fa-search text-third"></i><span class="d-md-down-none pl-1 text-third">{{ $lang.CarInspection.General.Search }}</span>
          </template>
          <SinisterSearch ref="Search" @Edit="onEdit" @ClearTabs="onClearTabs" @MoveTabIndex="moveTabIndex"/>
        </b-tab>
        <b-tab :title="$lang.CarInspection.General.Register" v-if="hasRole(this.roles.RD_REG_TABDETAILS) || hasRole(this.roles.RW_REG_TABDETAILS)" @click="setTabName('Details')">
          <template slot="title">
            <i class="fa fa-file-text-o text-third"></i><span class="d-md-down-none pl-1 text-third">{{ $lang.CarInspection.General.Register }}</span>
          </template>
          <Register ref="Register" :clear="clearAllTabs" />
        </b-tab>
        <b-tab :title="$lang.CarInspection.General.WorkshopReturn" v-if="hasRole(this.roles.RD_REG_TABWORKSHOP) || hasRole(this.roles.RW_REG_TABWORKSHOP)" @click="setTabName('WorkshopReturn')">
          <template slot="title">
            <i class="fa fa-image text-third"></i><span class="d-md-down-none pl-1 text-third">Imagens</span>
          </template>
          <SinisterWorkshopReturn :clear="clearAllTabs" ref="SinisterWorkshopReturn"/>
        </b-tab>
        <b-tab :title="$lang.CarInspection.General.Typing" v-if="hasRole(this.roles.RD_REG_TABDIGITATION) || hasRole(this.roles.RW_REG_TABDIGITATION)" @click="setTabName('Typing')">
          <template slot="title">
            <i class="fa fa-pencil-square-o text-third"></i><span class="d-md-down-none pl-1 text-third">{{ $lang.CarInspection.General.Typing }}</span>
          </template>
          <SinisterTyping @Edit="onReloadTyping" :clear="clearAllTabs" ref="SinisterTyping"/>
        </b-tab>
        <!--
        <b-tab :title="$lang.Sinister.General.History" @click="setTabName('History')">
          <template slot="title">
            <i class="fa fa-history text-third"></i><span class="d-md-down-none pl-1 text-third">{{ $lang.Sinister.General.History }}</span>
          </template>
          <SinisterHistory ref="History"/>
        </b-tab>
        -->
      </b-tabs>
  </div>
</template>

<script>
import Alerts from '@/components/forms/Alerts'
// import Tools from '@/components/tools/Tools.js'

import SinisterSearch from './search/SinisterSearch.vue'
import Register from './register/register.vue'
import SinisterScheduling from './scheduling/sinisterscheduling.vue'
import SinisterWorkshopReturn from './workshopreturn/SinisterWorkshopReturn.vue'
import SinisterTyping from './typing/SinisterTyping.vue'
import SinisterHistory from './history/SinisterHistory.vue'

import SinisterDetailsModel from '@/shared/models/regulation/auto/sinisterdetailsmodel'

import AccountMixin from '@/store/module/account/mixin'
import { actionTypes as AccountActions } from '@/store/module/account/actions'
import PermissionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'

const TAB_IDX_DETAILS = 1
const TAB_IDX_TYPING = 3
const TAB_DETAILS = 'Details'
const TAB_SCHEDULING = 'Scheduling'
const TAB_WORKSHOPRETURN = 'WorkshopReturn'
const TAB_REGULATION = 'Regulation'
const TAB_ANALYZE = 'Analyze'
const TAB_TYPING = 'Typing'
// const TAB_HISTORY = 'History'

export default {
  name: 'inspection',
  mixins: [ AccountMixin, PermissionMixin ],
  data () {
    return {
      roles: Roles,
      data: SinisterDetailsModel,
      objRegulationAuto: {},
      regulation: {},
      error: null,
      tabName: null,
      tabIndex: 0,
      isLoadDetails: false,
      isLoadScheduling: false,
      isLoadWorkshopReturn: false,
      isLoadRegulation: false,
      isLoadAnalyze: false,
      isLoadTyping: false,
      isLoadMonitoring: false,
      isLoadHistory: false,
      clearAllTabs: false
    }
  },
  created () {
    this[AccountActions.GET_LOGGED]()
      .then((response) => {
      })
  },
  components: {
    Alerts,
    SinisterSearch,
    Register,
    SinisterScheduling,
    SinisterWorkshopReturn,
    SinisterTyping,
    SinisterHistory,
    SinisterDetailsModel
  },
  watch: {
    tabIndex: function () {
      if (this.tabName === TAB_SCHEDULING && !this.isLoadScheduling) {
        if (this.objRegulationAuto) {
          this.$refs.Scheduling.onLoad(this.objRegulationAuto)
        }
        // TODO Load por demanda
        // this.isLoadScheduling = true
      }
      if (this.tabName === TAB_WORKSHOPRETURN && !this.isLoadWorkshopReturn) {
        this.$refs.SinisterWorkshopReturn.onLoad(this.objRegulationAuto)
        // TODO Load por demanda
      }
      if (this.tabName === TAB_REGULATION && !this.isLoadRegulation) {
        this.$refs.SinisterRegulation.onLoad(this.objRegulationAuto.id)
      }
      if (this.tabName === TAB_ANALYZE && !this.isLoadAnalyze) {
        this.$refs.SinisterAnalyze.onLoad(this.objRegulationAuto.id)
      }
      if (this.tabName === TAB_TYPING && !this.isLoadTyping) {
        this.$refs.SinisterTyping.onLoad(this.objRegulationAuto.id)
      }
    }
  },
  methods: {
    onClearTabs (clearFn) {
      this.objRegulationAuto.id = 'undefined'
      this.$refs.SinisterWorkshopReturn.$refs.CarInspectionHeader.onClear()
      // TODO REMOVER APÓS REFACTOR
      if (this.clearAllTabs) {
        this.clearAllTabs = false
        return
      }
      this.clearAllTabs = true
    },
    onChangeRegulation (value) {
      this.objRegulationAuto.id = value
    },
    onEdit (obj) {
      this.objRegulationAuto = obj
      if (this.$refs.Register) {
        this.$refs.Register.onEdit(this.objRegulationAuto)
      }
      this.isLoadScheduling = false
      this.isLoadAlbum = false
      this.isLoadAnalyze = false
      this.isLoadHistory = false
      this.isLoadWorkshopReturn = false

      this.tabIndex = TAB_IDX_DETAILS
      this.tabName = TAB_DETAILS
    },
    onReloadTyping (obj) {
      this.onEdit(obj)
      this.tabIndex = TAB_IDX_TYPING
      this.tabName = TAB_TYPING
    },
    moveTabIndex () {
      this.tabIndex = TAB_IDX_DETAILS
      this.tabName = TAB_DETAILS
      this.$refs.Register.onNew()
    },
    setTabName (name) {
      this.tabName = name
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          if (this.permissions[i].role === role) {
            result = true
          }
        }
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/inspection/inspection.vue